import { report } from './dataReporting';
import { getCookie } from './cookie';

// 应用启动上报
export function appLaunchReport() {
  if (!getCookie('StartTime')) {
    // 首次进来重载页面,加reload会导致下方的两个上报报不上去
    // location.reload();
    // 应用启动上报
    report(
      {
        attaId: '0f500063503',
      },
      true,
    );
    // id末位为3503的多上报到09500070656
    report(
      {
        attaId: '09500070656',
      },
      true,
    );
  }
};
